import { isUndefined, omitBy } from '@atlaskit/media-common';
export function createPlaybackAttributes(playbackState) {
  var isAutoPlay = playbackState.isAutoPlay,
    isHDAvailable = playbackState.isHDAvailable,
    isHDActive = playbackState.isHDActive,
    playerSize = playbackState.playerSize,
    isFullScreenEnabled = playbackState.isFullScreenEnabled,
    playbackSpeed = playbackState.playbackSpeed,
    status = playbackState.status,
    currentTime = playbackState.currentTime,
    volume = playbackState.volume,
    duration = playbackState.duration,
    isMuted = playbackState.isMuted;
  return omitBy({
    isAutoPlay: isAutoPlay,
    isHDAvailable: isHDAvailable,
    isHDActive: isHDActive,
    playbackSpeed: playbackSpeed,
    playerSize: playerSize,
    isFullScreenEnabled: isFullScreenEnabled,
    durationInSec: duration && parseInt("".concat(duration), 10),
    absoluteTimeInSec: currentTime && parseInt("".concat(currentTime), 10),
    relativeTime: duration && currentTime && duration > 0 ? Math.round(currentTime / duration * 100) / 100 : undefined,
    status: status,
    volume: volume,
    isMuted: isMuted
  }, isUndefined);
}